<template>
  <div id="resumePreview">
    I am resumePreview
  </div>
</template>

<script>
  export default {
    name:"ResumePreview"
  }
</script>

<style>
  #resumePreview{
    background: #ffffff;
    box-shadow:0 1px 3px 0 rgba(0,0,0,0.25)
  }
</style>



// WEBPACK FOOTER //
// src/components/ResumePreview.vue?758b90f2